import { isPrerendered } from '../utils/prerender'

export default {
  beforeCreate () {
    if (isPrerendered()) {
      window.prerenderData = {
        title: this.$meta().inject().title.text(),
        meta: this.$meta().inject().meta.text()
      }
    }
  }
}
